import * as React from "react";

import { SettingsLayout } from "@editor/components/shops-ui/settings/SettingsCard";
import { useCurrentProjectContext } from "@editor/contexts/CurrentProjectContext";

import { Outlet } from "react-router-dom";

const Integrations = () => {
  const { project } = useCurrentProjectContext();
  const isReploHosted = project?.hostingType === "replo";
  return (
    <SettingsLayout
      maxWidth={isReploHosted ? "max-w-[670px]" : "max-w-[975px]"}
    >
      <Outlet />
    </SettingsLayout>
  );
};

export default Integrations;
